import { render, staticRenderFns } from "./Grid.vue?vue&type=template&id=ae7a4b38&"
import script from "./Grid.vue?vue&type=script&lang=ts&"
export * from "./Grid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('ae7a4b38', component.options)
    } else {
      api.reload('ae7a4b38', component.options)
    }
    module.hot.accept("./Grid.vue?vue&type=template&id=ae7a4b38&", function () {
      api.rerender('ae7a4b38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/reusable/Grid/Grid.vue"
export default component.exports